<template>
	<div class="app-container userIndex">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{ pageName }}</h3>
			</div>

			<el-form :model="pageQuery" ref="queryForm" :inline="true" size="small" class="box_form">
				<el-form-item label="姓名" prop="contactName">
					<el-input v-model="pageQuery.contactName" placeholder="请输入姓名" clearable
						@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
				</el-form-item>

				<el-form-item label="联系电话" prop="contactMobile">
					<el-input v-model="pageQuery.contactMobile" placeholder="请输入联系电话" clearable
						@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
				</el-form-item>

				<el-form-item label="反馈时间" prop="date">
					<el-date-picker v-model="pageQuery.date" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期"
						value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
					<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="姓名" align="center" prop="contactName" />
				<el-table-column label="联系电话" align="center" prop="contactMobile" width="190" />
				<el-table-column label="反馈内容" align="center" prop="content" width="364" />
				<el-table-column label="反馈提交时间" align="center" prop="createTime" width="180" />
				<el-table-column label="用户手机号" align="center" prop="mobile" width="180" />
				<el-table-column label="处理说明" align="center" prop="handleContent" width="420">
					<template slot-scope="scope"> {{scope.row.handleContent}} </template>
				</el-table-column>
				<el-table-column label="处理时间" align="center" prop="handleTime" width="190" />
				<el-table-column label="处理人" align="center" prop="handleBy" />
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right"
					width="200">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleDetails(scope.row)">详情</el-button>
						<el-button size="small" plain type="success" @click="handleRegister(scope.row)"
							v-if="scope.row.feedbackTatus == 1">反馈登记</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="pageQuery.pageNum"
				:limit.sync="pageQuery.pageSize" @pagination="getMemberFeedbackPageList" />
		</el-card>

		<el-dialog :visible.sync="dialogDetailsShow" width="600px" append-to-body title="问题反馈详情">
			<el-descriptions :column="1">
				<el-descriptions-item label="提交人" labelClassName="elDescriptionsItem">
					<div class="descriptionsRow">
						<el-avatar size="80" :src="details.avatarUrl"></el-avatar>
						<span style="margin-left: 12px">{{ details.submitter }}</span>
					</div>
				</el-descriptions-item>
				<el-descriptions-item label="姓名"
					labelClassName="elDescriptionsItem">{{ details.contactName }}</el-descriptions-item>
				<el-descriptions-item label="提交时间"
					labelClassName="elDescriptionsItem">{{details.createTime}}</el-descriptions-item>
				<el-descriptions-item label="联系方式" labelClassName="elDescriptionsItem">
					{{ details.contactMobile }}
				</el-descriptions-item>
				<el-descriptions-item label="反馈内容"
					labelClassName="elDescriptionsItem">{{ details.content }}</el-descriptions-item>
				<el-descriptions-item label="图片" labelClassName="elDescriptionsItem">
					<div v-if="details.imgPathsList">
						<el-image v-for="(item, index) in details.imgPathsList" :key="index"
							style="width: 100px; height: 100px" :src="item" :preview-src-list="details.imgPathsList">
						</el-image>
					</div>
				</el-descriptions-item>
				<el-descriptions-item label="反馈登记" labelClassName="elDescriptionsItem">
					<span>{{ details.handleContent || "暂无说明" }}</span>
					<el-button size="small" style="margin-left: 12px" plain type="success" @click="openRegister"
						v-if="details.feedbackTatus == 1">立即反馈登记</el-button>
				</el-descriptions-item>
			</el-descriptions>
		</el-dialog>

		<el-dialog :visible.sync="dialogRegisterShow" width="600px" append-to-body title="反馈登记">
			<el-form ref="form" :model="form" :rules="rules" label-width="90px">
				<el-form-item label="处理说明:" prop="handleContent">
					<el-input type="textarea" placeholder="请输入处理说明" v-model="form.handleContent" maxlength="100"
						show-word-limit :autosize="{ minRows: 4, maxRows: 4 }">
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('form')">取 消</el-button>
				<el-button type="primary" @click="submitForm('form')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		memberFeedbackPageList,
		memberFeedbackDetails,
		memberFeedbackEdit,
	} from "@/api/sportManage/basic";
	export default {
		name: "userIndex",
		data() {
			return {
				pageName: "问题反馈",
				total: 0,
				pageQuery: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				details: {},
				form: {},
				loading: false,
				dialogDetailsShow: false,
				dialogRegisterShow: false,
				rules: {
					handleContent: [{
						required: true,
						message: "请输入处理说明",
						trigger: "blur"
					}, ],
				},
			};
		},
		created() {
			this.getMemberFeedbackPageList();
		},
		methods: {
			async getMemberFeedbackPageList() {
				let res = await memberFeedbackPageList({
					...this.pageQuery,
				});
				if (res.code === 200) {
					this.list = res.data.list;
					this.total = res.data.total;
				}
			},
			handleQuery() {
				this.pageQuery.startTime = this.pageQuery.date ?
					this.pageQuery.date[0] :
					"";
				this.pageQuery.endTime = this.pageQuery.date ?
					this.pageQuery.date[1] :
					"";
				this.pageQuery.pageNum = 1;
				this.getMemberFeedbackPageList();
			},
			async handleDetails(row) {
				this.dialogDetailsShow = true;
				let res = await memberFeedbackDetails({
					id: row.id
				});
				if (res.code === 200) {
					this.details = {
						...res.data,
						imgPathsList: res.data.imgPaths.split(","),
					};
					this.form = {
						...res.data
					}
					console.log(this.details);
				}
				console.log(res);
			},
			handleRegister(row) {
				this.form = {
					...row
				};
				this.dialogRegisterShow = true;
			},
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = {
							...this.form,
						};
						console.log(data);
						let res = await memberFeedbackEdit(data);
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: "success",
							});
							this.dialogRegisterShow = false;
							this.getMemberFeedbackPageList();
						} else {
							this.$message({
								message: res.msg,
								type: "error",
							});
						}
					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogRegisterShow = false;
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this.pageQuery.startTime = "";
				this.pageQuery.endTime = "";
				this.getMemberFeedbackPageList();
			},
			openRegister() {
				this.dialogDetailsShow = false
				this.dialogRegisterShow = true
			}
		},
	};
</script>

<style lang="scss">
	@import "../../../assets/styles/common.scss";

	.userIndex {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;
	}

	.descriptionsRow {
		display: flex;
		align-items: center;
	}

	.elDescriptionsItem {
		width: 80px;
		display: flex;
		align-items: center !important;
		justify-content: flex-end;
	}
</style>